import { createAction } from 'redux-actions';

export const updateGuestReservationSearchQuery = createAction(
  'UPDATE_GUEST_RESERVATION_SEARCH_QUERY'
);
